module.exports = __webpack_public_path__ + "static/media/deactiveimg.9ef46fa0.png";